import React, { useState } from 'react';
import {
  Grid,
  Box,
  Typography,
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';
import { useOutageLeftPanelState } from '../../providers/OutageLeftPanelStateProvider';
import { useTranslation } from '../../../../hooks/useTranslation';
import ExtensionIcon from '../../../../static/outageIconsV2/extension.svg';
import colors from '../../../../themes/main-colors';
import { ReportOutageByCountyCity } from '../report-outage-by-county-city/ReportOutageByCountyCity';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    expandedContainer: {
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      padding: theme.spacing(3.75, 2.5),
      backgroundColor: colors.white,
      borderBottom: `1px solid ${colors.grey2}`,
    },
    expandedHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1.5),
    },
    collapsedContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '8px',
      padding: theme.spacing(1.25, 0.5),
      textAlign: 'center',
      cursor: 'pointer',
    },
    title: {
      fontSize: 16,
      fontWeight: 600,
    },
    text: {
      fontSize: 16,
    },
    collapsedText: {
      fontSize: 14,
      fontWeight: 600,
    },
    expandedIcon: {
      width: 25,
      height: 25,
    },
    collapsedIcon: {
      width: 20,
      height: 20,
    },
  }),
);

export const ViewByCountyZipcode: React.FC = () => {
  const { panelOpen: expanded } = useOutageLeftPanelState();
  const { t } = useTranslation();
  const classes = useStyles();
  const [openCountyCityPanel, setOpenCountyCityPanel] = useState(false);

  return (
    <>
      {expanded ? (
        <Box
          className={classes.expandedContainer}
          onClick={() => setOpenCountyCityPanel(true)}
        >
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <ExtensionIcon className={classes.expandedIcon} />
            </Grid>
            <Grid item>
              <Typography className={classes.title}>
                {t('VIEW_BY_COUNTY_ZIP')}
              </Typography>
            </Grid>
          </Grid>
          <Typography className={classes.text}>
            {t('LIST_BY_COUNTY_AND_ZIP')}
          </Typography>
        </Box>
      ) : (
        <Box
          className={classes.collapsedContainer}
          onClick={() => setOpenCountyCityPanel(true)}
        >
          <ExtensionIcon className={classes.collapsedIcon} />
          <Typography className={classes.collapsedText}>
            {t('COUNTY_OR_ZIP')}
          </Typography>
        </Box>
      )}
      {openCountyCityPanel && (
        <ReportOutageByCountyCity
          open={openCountyCityPanel}
          setOpen={setOpenCountyCityPanel}
        />
      )}
    </>
  );
};
